import { AppComponent } from './app.component';

import { ErrorHandler, LOCALE_ID, NgModule, APP_INITIALIZER  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';

import { AuthInterceptor } from 'src/app/core/interceptor/auth.interceptor';
import { LayoutModule } from './layout/layout.module';
import { registerLocaleData } from '@angular/common';
import { CookieService } from "ngx-cookie-service";
import { UsersService } from './data/services/users.service';
import { GlobalErrorHandler } from './core/errors/global-error-handler';

import localeEsES from '@angular/common/locales/es';
import { MatDialogModule } from '@angular/material/dialog';
import { ErrorDialogService } from './core/errors/error-dialog.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleErrorDialogComponent } from './shared/errors/simple-error-dialog/simple-error-dialog.component';
import { MatNativeDateModule } from '@angular/material/core';
import { lastValueFrom } from 'rxjs';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

registerLocaleData(localeEsES)

export function loadUser(usersService: UsersService) {
  return () => lastValueFrom(usersService.loadUser());
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SimpleErrorDialogComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    LayoutModule,
    MatDialogModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    UsersService,
    { provide: APP_INITIALIZER, useFactory: loadUser, deps: [UsersService], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    CookieService,
    ErrorDialogService,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
